<template>
    <div
        class="login-register-modal"
        :class="{
            'mobile-login-container': isMobile,
            'mobile-login-bg': isMobile && currentLoginStep === 1 && showMessageCont === 'login',
        }"
    >
        <!-- 上一步按钮-登录 -->
        <div class="login-register-head">
            <div class="head-sec-control left-section">
                <div
                    v-if="showMessageCont === 'login' && currentLoginStep !== 1"
                    class="prev-step-cont"
                    @click="prevLoginStep"
                >
                    <n-icon v-if="isMobile" size="20" class="custom-icon">
                        <img class="icon-img" src="@/assets/icons/icon_back_m.svg" />
                    </n-icon>
                    <img v-else src="@/assets/icons/icon_pre_step.svg" />
                </div>

                <!-- 上一步按钮-注册 -->
                <div
                    v-if="showMessageCont === 'register' && (createAccountStep !== 5 && createAccountStep !== 7)"
                    class="prev-step-cont"
                    @click="prevRegisterStep"
                >
                    <n-icon v-if="isMobile" size="20" class="custom-icon">
                        <img class="icon-img" src="@/assets/icons/icon_back_m.svg" />
                    </n-icon>
                    <img v-else src="@/assets/icons/icon_pre_step.svg" />
                </div>

                <!-- 上一步按钮-忘记密码 -->
                <div
                    v-if="showMessageCont === 'forgetPassword'"
                    class="prev-step-cont"
                    @click="prevForgetPasswordStep"
                >
                    <n-icon v-if="isMobile" size="20" class="custom-icon">
                        <img class="icon-img" src="@/assets/icons/icon_back_m.svg" />
                    </n-icon>
                    <img v-else src="@/assets/icons/icon_pre_step.svg" />
                </div>
            </div>
            <div class="head-sec-control  center-section">
                <template v-if="!isMobile">
                    <div
                        v-if="createAccountStep !== 5 && createAccountStep !== 6"
                        class="logo-cont"
                        :class="{
                            'pdt-fix': createAccountStep === 4,
                            'mobile-cont': isMobile && currentLoginStep === 1 && showMessageCont === 'login',
                        }"
                    >
                        <div v-show=" !(isMobile && showMessageCont === 'login' && currentLoginStep !== 1)" :class="{ 'step-text': isMobile && currentLoginStep === 1 && showMessageCont === 'login' }">
                            {{ loginAndRegisterTitle }}
                        </div>
                    </div>
                </template>
            </div>
            <div class="head-sec-control  right-section">
                <!-- 关闭按钮 -->
                <div v-show="showClose" class="close-cont" @click="closeLoginAndRegisterModal">
                    <img src="@/assets/icons/icon_close.svg" />
                </div>
            </div>
        </div>

        <template v-if="isMobile">
            <!-- 关闭按钮 -->
            <div v-show="showClose" class="close-cont" @click="closeLoginAndRegisterModal">
                <img src="@/assets/icons/icon_close.svg" />
            </div>

            <div v-if="createAccountStep !== 5 && createAccountStep !== 6" class="logo-cont" :class="{
                    'pdt-fix': createAccountStep === 4,
                    'mobile-cont': isMobile && currentLoginStep === 1 && showMessageCont === 'login',
                }"
            >
                <img src="@/assets/images/layout/APP_LOGO.svg" />
                <div v-show=" !(isMobile && showMessageCont === 'login' && currentLoginStep !== 1)" :class="{ 'step-text': isMobile && currentLoginStep === 1 && showMessageCont === 'login' }">
                    {{ loginAndRegisterTitle }}
                </div>
            </div>
        </template>

        <!-- 登陆信息容器 -->
        <div v-if="showMessageCont === 'login'" class="login-container">
            <template v-if="isMobile">
                <LoginMainMobile
                    v-model:currentStep="currentLoginStep"
                    @on-close="closeLoginAndRegisterModal"
                    @on-register="_handleShowRegister"
                    @on-forgot-password="_handleEditPassword"
                ></LoginMainMobile>
            </template>
            <template v-else>
                <LoginMain
                    v-model:currentStep="currentLoginStep"
                    @on-close="closeLoginAndRegisterModal"
                    @on-register="_handleShowRegister"
                    @on-forgot-password="_handleEditPassword"
                ></LoginMain>
            </template>
        </div>

        <!-- 注册信息容器 -->
        <div v-if="showMessageCont === 'register'" class="register-container">
            <RegisterMain
                v-model:currentStep="createAccountStep"
                :cur-base-info-step="curCompletePersonalInformationStep"
                @on-login="_handleShowLogin"
                @on-changeuser-info-step="onChangeCurUserInfoStep"
                @on-close="closeLoginAndRegisterModal"
            ></RegisterMain>
        </div>

        <!-- 忘记密码容器 -->
        <div
            v-if="showMessageCont === 'forgetPassword'"
            class="forget-password-container"
        >
            <ForgetPasswordMain
                v-model:currentStep="forgetPasswordStep"
                @on-login="_handleShowLogin"
            ></ForgetPasswordMain>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, nextTick, watch } from "vue";
import { NIcon } from "naive-ui";
// import { ChevronBack } from "@vicons/ionicons5";
import LoginMain from "./setModules/LoginMain.vue";
import LoginMainMobile from "./setModules/LoginMainMobile.vue";
import RegisterMain from "./setModules/RegisterMain.vue";
import ForgetPasswordMain from "./setModules/ForgetPasswordMain.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useNavigatorSystem } from "@/composables/useNaviSystem";

const props = defineProps({
    showClose: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
    showRegister: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
    showForgotpasword: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
});
const emits = defineEmits(["closeLoginAndRegisterModal"]);
const store = useStore();
const router = useRouter();
const { isMobile } = useNavigatorSystem();

const showMessageCont = ref<string>("login");
const currentLoginStep = ref<number>(1);
const createAccountStep = ref<number>(1);
const forgetPasswordStep = ref<number>(1);
const curCompletePersonalInformationStep = ref<number>(1);

// 弹窗标题
const loginAndRegisterTitle = computed(() => {
    let res = "Log In";
    switch (showMessageCont.value) {
        case "login":
            res =
                currentLoginStep.value === 1
                    ? isMobile.value
                        ? "Charm"
                        : "Log In"
                    : "Log In";
            break;
        case "register":
            if (createAccountStep.value === 2) {
                res = "Verify your identity";
            } else if (createAccountStep.value === 4) {
                res =
                    curCompletePersonalInformationStep.value === 1
                        ? "Complete personal information"
                        : "Your Interests";
            } else {
                res = "Create Account";
            }
            break;
        case "forgetPassword":
            res =
                forgetPasswordStep.value === 1 ||
                forgetPasswordStep.value === 2 ||
                forgetPasswordStep.value === 3
                    ? "Forgotten Password？"
                    : "";
            break;
        default:
            break;
    }
    return res;
});

const onChangeCurUserInfoStep = (step: number) => {
    curCompletePersonalInformationStep.value = step;
};

const _handleShowLogin = () => {
    showMessageCont.value = "login";
};

const _goToPageDoctorProfile = () => {
    router.push({ path: "/user/profile", query: { from: "user" } });
};

const _handleShowRegister = async (type?: string) => {
    if (type === "thirdlogin") {
        const cacheUserThirdType = store.getters["user/getUserThirdType"];
        if (cacheUserThirdType === "0") {
            showMessageCont.value = "register";
            createAccountStep.value = 3;
        } else {
            await store.dispatch("user/fetchUserInfo");
            _goToPageDoctorProfile();
            nextTick(() => {
                closeLoginAndRegisterModal();
            });
        }
    } else {
        showMessageCont.value = "register";
    }
};

const _setCreateAccountStep = (step: number) => {
    createAccountStep.value = step ?? 1;
}

const _handleShowForgotPassword = () => {
    showMessageCont.value = "forgetPassword";
}

const _setForgotPasswordStep = (step: number) => {
    forgetPasswordStep.value = step ?? 1;
}

// 忘记密码
const _handleEditPassword = () => {
    _handleShowForgotPassword();
    _setForgotPasswordStep(1);
};

//登录时后退一步
const prevLoginStep = () => {
    if (currentLoginStep.value === 2) {
        currentLoginStep.value = 1;
    } else {
        currentLoginStep.value--;
    }
};

// 注册时后退一步
const prevRegisterStep = () => {
    if (createAccountStep.value === 1) {
        showMessageCont.value = "login";
    } else if (createAccountStep.value === 6) {
        createAccountStep.value = 4;
    } else if (createAccountStep.value === 7 || createAccountStep.value === 8) {
        createAccountStep.value = 1;
    } else if(createAccountStep.value === 4) {
        if (curCompletePersonalInformationStep.value > 1) {
            curCompletePersonalInformationStep.value--;
        } else {
            createAccountStep.value--;
        }
    }else{
        createAccountStep.value--;
    }
};

// 忘记密码时后退一步
const prevForgetPasswordStep = () => {
    if (forgetPasswordStep.value === 1) {
        showMessageCont.value = "login";
    } else if (forgetPasswordStep.value === 4) {
        forgetPasswordStep.value -= 2;
    } else {
        forgetPasswordStep.value--;
    }
};

// 关闭登陆注册弹框
const closeLoginAndRegisterModal = () => {
    emits("closeLoginAndRegisterModal");
    showMessageCont.value = "login";
    createAccountStep.value = 1;
};

const _initUserLoginInfo = () => {
    //清理缓存 undo
    //清理用户信息 undo
};

watch(
    ()=>props.showRegister,
    (n:boolean) => {
        if(n){
            nextTick(() => {
                _handleShowRegister();
                _setCreateAccountStep(7);
            })
        }
    },
    {immediate: true}
);

watch(
    ()=>props.showForgotpasword,
    (n:boolean) => {
        if(n){
            nextTick(() => {
                _handleShowForgotPassword();
                _setForgotPasswordStep(3);
            })
        }
    },
    {immediate: true}
);

onMounted(() => {
    nextTick(() => {
        _initUserLoginInfo();
    });
});
</script>

<style lang="scss" scoped>
.login-register-modal {
    position: relative;
    width: 620px;
    height: 720px;
    padding: 0 60px;
    border-radius: 28px;
    box-sizing: border-box;
    background-color: #fff;

    .login-register-head{
        display: flex;
        height: 40px;
        margin-top: 20px;
        align-items: center;
        justify-content: center;
    }

    .logo-cont {
        display: flex;

        img {
            width: 58px;
            height: 58px;
        }

        div {
            padding-top: 0px;
            color: #000;
            text-align: center;
            font-family: "San Francisco Text";
            font-size: 24px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
        }
    }

    .prev-step-cont {
        position: absolute;
        top: 30px;
        left: 20px;
        cursor: pointer;

        .custom-icon {
            .icon-img {
                width: 100%;
                height: 100%;
                object-fit: fill;
            }
        }

        > img {
            width: 40px;
            height: 20px;
        }
    }

    .close-cont {
        position: absolute;
        top: 30px;
        right: 20px;
        cursor: pointer;

        img {
            width: 20px;
            height: 20px;
        }
    }

    .login-container{
        margin-top: 40px;
    }
    .register-container{
        margin-top: 40px;
    }
    .forget-password-container{
        margin-top: 40px;
    }
}
@media screen and (max-width: 1024px) and (min-width: 744px) {
}
@media screen and (max-width: 744px) {
    .login-register-modal {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 20px 12px;
        border-radius: 0;
        overflow-y: auto;
        z-index: 1000;

        .login-register-head{
            margin-top: 0px;
        }

        .logo-cont {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-top: 10px;
            padding-bottom: 10px;
            img {
                width: 58px;
                height: 58px;
            }

            div {
                padding-top: 20px;
                font-size: 20px;
            }
        }

        .mobile-cont {
            img {
                width: 100px;
                height: 100px;
            }
            div {
                color: #000000;
                
                font-size: 44px;
                font-weight: 600;
            }
            .step-text {
                color: #ffffff;
            }
        }

        .pdt-fix {
            padding-top: 0px;
        }

        .prev-step-cont {
            position: absolute;
            top: 20px;
            left: 20px;

            > img {
                width: 30px;
                height: 15px;
            }
        }

        .close-cont {
            position: absolute;
            top: 20px;
            right: 20px;
            width: 20px;
            height: 20px;
            padding: 0px;
            border-radius: 50%;
            background-color: #ffffff;

            img {
                width: 20px;
                height: 20px;
            }
        }

        .login-container{
            margin-top: 10px;
        }
        .register-container{
            margin-top: 10px;
        }
        .forget-password-container{
            margin-top: 10px;
        }
    }
    .mobile-login-container {
        background-color: #fafafa;
    }
    .mobile-login-bg {
        background-color: #000;
    }
}
</style>
